import { useLocation, useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo";
import ListContainer from "../../../../components/_utils/CommonListView/ListContainer";
import ListTextWithIcon from "../../../../components/_utils/CommonListView/ListSubComponent/ListTextWithIcon";
import CommonToast from "../../../../components/_utils/CommonToast";
import TickerAnimation from "../../../../components/_utils/TickerAnimation";
import accountNameStandardised from "../../../../utils/accountNamestandardised";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import { standardAccountNumberFormat } from "../../../../utils/standardAccountNumberFormat";
import "./index.css";

const BeneAccountListView = ({
  subType,
  data,
  typepop,
  handleButtonClick,
  internalAccount,
  associateAccount,
  showSearchBar,
  beneAccountId,
  txnPayLoad,
  flow,
  accountType,
  scheduleIntenralTxn,
  isLabelClicked,
  setLabelAccounts,
  LabelAccounts,
  setlableInput,
  Labeldata,
  setLabeldata,
  associateTxn,
  filterRef,
  type,
  onCardNavigate,
  setOpenBeneAssociate,
  setIsalertPopup,
  setFlowSelectedId,
  classifiedFlow,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "rejected":
      case "blocked":
        return "var(--failed)";
      case "archived":
        return "var(--text-secondary)";
      case "rejected":
        return "var(--failed)";
      case "hold":
        return "var(--queued)";
      case "queued":
        return "var(--queued)";
      case "all":
        return "var(--text-primary)";
      case "settled":
        return "var(--settled)";
      default:
        return "var(--text-primary)";
    }
  };

  const listdata = data || [];

  return (
    <>
      <div
        className={
          listdata?.length === GlobalConfiguration?.lengthCheckOne
            ? "p-padding-md w-width-full h-height-full"
            : "standard-list-view-alignment"
        }
      >
        {listdata ? (
          listdata?.map((item) => {
            const redirectUrl =
              internalAccount === "internalAccount" ||
              accountType === "internal"
                ? `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/${item.id}`
                : `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${item.id}`;
            return (
              <ListContainer
                hoverHeight={GlobalConfiguration.beneAccountListHoverHeight}
                filterRef={filterRef}
                key={item.id}
                isSelected={
                  Array.isArray(LabelAccounts) &&
                  LabelAccounts.includes(item.id)
                }
                isDisabled={
                  item.id == beneAccountId ||
                  (isLabelClicked && item?.approval_status === "archived") ||
                  (!(
                    associateAccount ||
                    (associateTxn === "associateTxn" &&
                      (item?.approval_status === "blocked" ||
                        item?.approval_status === "archived" ||
                        item?.approval_status === "rejected"))
                  ) &&
                    typepop === "popup" &&
                    (item?.approval_status === "blocked" ||
                      item?.approval_status === "archived" ||
                      item?.approval_status === "rejected"))
                }
                context={item}
                onClickHandler={async () => {
                  if (classifiedFlow) {
                    navigate(
                      `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${item.id}`,
                      {
                        replace: true,
                      },
                    );
                    return;
                  }
                  if (type === "activeInactive") {
                    setIsalertPopup(true);
                    setFlowSelectedId(item?.id);
                    return;
                  }
                  if (associateAccount && subType === "reimbursement") return;
                  if (onCardNavigate) {
                    onCardNavigate(redirectUrl);
                    return;
                  }
                  if (
                    typepop === "popup" &&
                    scheduleIntenralTxn &&
                    (item?.approval_status === "blocked" ||
                      item?.approval_status === "archived" ||
                      item?.approval_status === "rejected" ||
                      (txnPayLoad.ownerBankAccountNo === item?.bank_acc_no &&
                        txnPayLoad?.ownerBankIFSC === item?.ifsc_code &&
                        txnPayLoad?.ownerPan === item?.pan_no))
                  ) {
                    CommonToast({
                      text: "Same Account can't be selected",
                      icon: ICONS?.ERROR_WHITE_CIRCLE,
                      variant: "var(--error)",
                      buttonNeeded: false,
                    });
                    return;
                  } else if (
                    typepop === "popup" &&
                    (item?.approval_status === "blocked" ||
                      item?.approval_status === "archived" ||
                      item?.approval_status === "rejected") &&
                    !associateAccount
                  ) {
                    return;
                  } else if (typepop === "popup" && !associateAccount) {
                    if (isLabelClicked) {
                      if (LabelAccounts.includes(item.id)) {
                        setLabelAccounts(
                          LabelAccounts.filter((id) => id !== item.id),
                        );
                      } else {
                        setLabelAccounts([...LabelAccounts, item.id]);
                        setLabeldata([...Labeldata, item]);
                      }
                      setlableInput(false);
                    } else {
                      handleButtonClick(item);
                    }
                  } else {
                    if (!isLabelClicked) {
                      let selection = window.getSelection();

                      if (
                        selection.toString().length ===
                        GlobalConfiguration.lengthCheckZero
                      ) {
                        if (type !== "viewOnlyCards") {
                          if (onCardNavigate) {
                            onCardNavigate(redirectUrl);
                            return;
                          }
                          if (setOpenBeneAssociate) setOpenBeneAssociate(false);

                          navigate(redirectUrl, {
                            state: {
                              isViewAll:
                                location.pathname ===
                                "/beneficiary_account_dashboard/beneficiary_account_view_all"
                                  ? true
                                  : false,
                            },
                          });

                          if (LabelAccounts?.includes(item.id)) {
                            setLabelAccounts(
                              LabelAccounts.filter((id) => id !== item.id),
                            );
                          } else {
                            setLabelAccounts([...LabelAccounts, item.id]);
                            setLabeldata([...Labeldata, item]);
                          }
                        }
                      }
                    } else {
                      if (LabelAccounts.includes(item.id)) {
                        setLabelAccounts(
                          LabelAccounts.filter((id) => id !== item.id),
                        );
                      } else {
                        setLabelAccounts([...LabelAccounts, item.id]);
                        setLabeldata([...Labeldata, item]);
                      }
                      setlableInput(false);
                    }
                  }
                }}
              >
                <list-body>
                  <div className="w-full flex justify-between pr-padding-sm gap-x-gap-sm py-padding-sm">
                    <div className={`flex flex-col gap-y-gap-sm w-full`}>
                      <div className="w-full flex gap-x-gap-sm">
                        <div className="bg-text-primary py-padding-xs flex justify-center items-center px-padding-sm rounded-r-border-radius-md">
                          <CommonBankLogo
                            variant="small"
                            ifsc={item.ifsc_code}
                          />
                        </div>
                        <p className="text-text-primary text-font-xs flex-1 min-w-standard-account-min-width truncate flex font-normal">
                          <TickerAnimation
                            text={standardAccountNumberFormat(
                              item?.bank_acc_no,
                              true,
                            )}
                          />
                        </p>
                        <div className="border-l border-primary-bg"></div>
                        <div className="flex gap-x-gap-sm justify-end items-center">
                          <p
                            style={{
                              color: getStatusColor(item?.approval_status),
                            }}
                            className={` text-font-xs font-semibol capitalize min-w-standard-approval-status-min-width text-right`}
                          >
                            {item?.approval_status}
                          </p>

                          <img
                            style={{
                              display: isLabelClicked ? "flex" : "none",
                            }}
                            className="w-icon-sm h-icon-sm flex-shrink-0 cursor-pointer"
                            src={
                              Array.isArray(LabelAccounts) &&
                              LabelAccounts.includes(item.id)
                                ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                                : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg"
                            }
                            alt=""
                          />
                        </div>
                      </div>
                      <p
                        className={`text-font-xs pl-padding-sm  text-text-primary flex-1 truncate font-normal`}
                      >
                        <TickerAnimation
                          text={accountNameStandardised(item?.name)}
                        />
                      </p>
                    </div>
                  </div>
                </list-body>
                <list-hover>
                  <ListTextWithIcon
                    type={"text"}
                    text={item?.labels?.join(", ") || "No labels assigned "}
                    iconComponentArray={[
                      {
                        icon: "https://q2pay.in/new_assets/common/view_all/label.svg",
                      },
                    ]}
                  />
                </list-hover>
              </ListContainer>
            );
          })
        ) : (
          <div
            className="flex flex-col items-center justify-center m-auto w-full h-full"
            style={{
              height:
                typepop === "popup" && !showSearchBar
                  ? ""
                  : typepop === "popup" && showSearchBar
                    ? "var(--height-full)"
                    : "",
              overflowY: "scroll",

              scrollbarWidth: "none",
            }}
          >
            <img
              src={ICONS?.NO_DATA_FOUND}
              alt="No accounts found"
              className="bene-acc-no-acc-image"
            />
            <p className="bene-acc-no-beneaccount-text">No accounts found.</p>
          </div>
        )}
      </div>
    </>
  );
};

export default BeneAccountListView;
